import { useContext, useEffect, useState } from 'react'

import { Box, Tabs } from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { CompanyCard } from '../../components/CompanyCard/company-card.comp'
import { CompanyProduction } from '../../components/CompanyProduction/company-production.comp'
import { Documents } from '../../components/Documents/documents.comp'
import { CompanyAddressForm } from '../../components/EditCompanyAdressModal/edit-company-address-modal.types'
import { CompanyDataForm } from '../../components/EditCompanyModal/edit-company-modal.types'
import { ProductionCapacity } from '../../components/ProductionCapacity/production-capacity.comp'
import { ProviderRisks } from '../../components/ProviderRisks/provider-risks.comp'
import { CompanySegment } from '../../sdk/common/company.enum'
import { sdk } from '../../services/sdk'

import { MyCompanyContext, MyCompanyProvider } from './my-company.context'

export const MyCompanyComp = () => {
  const [tabs, setTabs] = useState(['Documentos', 'Riscos Socioambientais'])
  const [activeTab, setActiveTab] = useState<string>(tabs[0])

  const { company, user, userType, documents, expiredDocuments, actions } =
    useContext(MyCompanyContext)
  useEffect(() => {
    actions.getCompany()
    if (userType === CompanySegment.SUBCONTRACTOR) {
      setTabs([...tabs, 'Capacidade Produtiva', 'Produção mensal'])
    }
  }, [])

  const handleEditData = async (data: CompanyDataForm) => {
    await sdk.company.changeSegment(data.segment, company?.email ?? '')

    actions.getCompany()
  }

  const handleEditAddress = async (data: CompanyAddressForm) => {
    await sdk.company.changeAddress(data, company?.email ?? '')

    actions.getCompany()
  }

  const fetchDocuments = async () => {
    await actions.getDocuments(company?.id ?? '')
  }

  useEffect(() => {
    if (activeTab === 'Documentos') fetchDocuments()
  }, [activeTab])
  const theme = useTheme()

  return (
    <Box width="100%" direction="column" gap={3} padding={3}>
      <CompanyCard
        title="Dados da minha empresa"
        data={company}
        user={user}
        onEdit={handleEditData}
        onEditLocation={handleEditAddress}
      />

      <Box
        width="100%"
        direction="column"
        gap={2}
        padding={2}
        borderRadius={theme.border_radius.box}
        boxShadow={theme.box_shadow.card}
        backgroundColor="white"
        minHeight="300px"
      >
        <Tabs
          active={activeTab}
          tabs={tabs}
          onChangeTab={(_tab) => setActiveTab(_tab)}
        />
        {activeTab === 'Documentos' && (
          <Documents
            documents={documents}
            expiredDocuments={expiredDocuments}
            onAddDocument={actions.addDocument}
            onDeleteDocument={actions.deleteDocument}
          />
        )}
        {activeTab === 'Riscos Socioambientais' && (
          <ProviderRisks
            socialEnvironmentalRisk={
              company?.socialEnvironmentalRisks ?? undefined
            }
          />
        )}
        {activeTab === 'Capacidade Produtiva' && (
          <ProductionCapacity companyId={company?.id ?? ''} />
        )}
        {activeTab === 'Produção mensal' && (
          <CompanyProduction companyId={company?.id ?? ''} />
        )}
      </Box>
    </Box>
  )
}

export const MyCompany = () => {
  return (
    <MyCompanyProvider>
      <MyCompanyComp />
    </MyCompanyProvider>
  )
}
